
    <div class="top-dialog-content">
        <div  class="dialog-close">
            <span class="close-button" (click)="close()">
              <span>{{'admin.store.close'|translate}}</span>
              <i class="fas fa-times"></i>
            </span>
          </div>
    <div class="form-group" id="popup-content">
        <ng-container *ngIf="showInitialContent; else newTokenTemplate">
            <div class="text-primary font-size-header mb-3">{{'admin.global.apiTokenGeneration'| translate}}</div>
            <p>{{'admin.global.clickGenerateToken' | translate}}</p>
            <p><strong>{{'admin.global.overwriteGenerateToken' | translate}}</strong></p>
            <button type="button" class="btn btn-primary btn-class px-4" (click)="generateNewToken()">
                {{'admin.global.generateNewToken' | translate}}
            </button>
        </ng-container>
        <ng-template #newTokenTemplate>
            <div class="text-primary font-size-header mb-3">{{'admin.global.newApiToken' | translate}}</div>
            <p><strong>{{'admin.global.newApiTokenSecurityWarning'| translate}}</strong></p>
            <div class="form-group">
                <label for="token-description">
                    {{'admin.global.yourApiTokenGrants' | translate}}
                </label>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <label class="d-flex">
                            <input type="text" class="form-control" id="token-description"
                                placeholder="Enter description" [(ngModel)]="description">
                            <i class="far fa-copy copyUrlIcon ml-2 my-auto" title="Copy" (click)="copyToken()"></i>
                        </label>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>